import { User } from '@ps/auth-data-access';

import type {
  BuyerFeatureEntitlementFlags,
  FeatureEntitlement,
  OperatorFeatureEntitlementFlags,
  SupplierFeatureEntitlementFlags,
} from '../models/entitlement.model';

const NONE = 'none';

type RoleEntitlementFlags =
  | OperatorFeatureEntitlementFlags
  | SupplierFeatureEntitlementFlags
  | BuyerFeatureEntitlementFlags;

// serviceOperator login role maps to full access in entitlement flags.
// API may omit the serviceOperator flag, so we check both serviceOperator and full.
function resolveOperatorLevels(level: string | undefined): string[] {
  if (!level || level === NONE) return [];
  if (level === 'serviceOperator') return ['serviceOperator', 'full'];
  return [level];
}

function isUserEntitledToFeature(
  entitlement: FeatureEntitlement,
  user: User,
): boolean {
  if (entitlement.status !== 'Active') {
    return false;
  }

  const entitledOn = (
    flags: RoleEntitlementFlags,
    level: string | undefined,
  ): boolean => {
    if (!level || level === NONE) {
      return false;
    }
    return Reflect.get(flags, level) === true;
  };

  const operatorEntitled = resolveOperatorLevels(user.operatorAccessLevel).some(
    (level) => entitledOn(entitlement.operator, level),
  );

  return (
    operatorEntitled ||
    entitledOn(entitlement.buyer, user.buyerAccessLevel) ||
    entitledOn(entitlement.supplier, user.supplierAccessLevel)
  );
}

export function filterEntitlementsForUser(
  entitlements: FeatureEntitlement[],
  user: User,
): FeatureEntitlement[] {
  return entitlements.filter((entitlement) =>
    isUserEntitledToFeature(entitlement, user),
  );
}
